import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import { pt, en, es } from 'vuetify/lib/locale'
import { calcLocaleToVuetifyLang, resolveInitialLocale } from '@/helpers/locale'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { pt, en, es },
    current: calcLocaleToVuetifyLang(resolveInitialLocale()),
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#dd0041',
      },
    },
  },
})
